var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M13.558 9.47 8.058 4 7 5.064 11.965 10 7 14.94l1.058 1.064 5.5-5.47a.75.75 0 0 0 0-1.064","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }